module.exports = __webpack_public_path__ + "img/4.6b795d39.png";